import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Modal from "@material-ui/core/Modal"
import { FaWindowClose } from "react-icons/fa"
import Grid from "@material-ui/core/Grid"
import modalStyles from "../styles/components/modal.module.scss"
import LeaveReview from "./leaveReview"

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const styles = theme => ({
  paper: {
    position: "absolute",
    backgroundColor: "#f3f3f3",
    boxShadow: theme.shadows[5],
    padding: 0,
    outline: "none",
  },
})

class SimpleModal extends React.Component {
  state = {
    open: false,
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props

    return (
      <div style={{ position: "relative" }}>
        <button
          className={modalStyles.button}
          onClick={this.handleOpen}
          onKeyDown={this.handleOpen}
          tabIndex={0}
        >
          Write A Review
        </button>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            <div
              role="button"
              tabIndex={0}
              onClick={this.handleClose}
              onKeyDown={this.handleClose}
              style={{
                position: "absolute",
                right: "0",
                margin: "5px",
                cursor: "pointer",
              }}
            >
              <FaWindowClose color="red" />
            </div>
            <Grid container className={modalStyles.gridContainer}>
              <LeaveReview />
            </Grid>
          </div>
        </Modal>
      </div>
    )
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
}

// We need an intermediary variable for handling the recursive nesting.
const SimpleModalWrapped = withStyles(styles)(SimpleModal)

export default SimpleModalWrapped
